export default __webpack_public_path__ + "static/order-new-31de8b4bba401f4fd64834bb17b39b90.png";